export type TitleProps = {
  html: string
  icon_l?: string
  icon_r?: string
  cns?: {
    container?: string
    icon_l?: string
    icon_r?: string
  }
}
